import { render, staticRenderFns } from "./gift-animation.vue?vue&type=template&id=f2c866f4&scoped=true&"
import script from "./gift-animation.vue?vue&type=script&lang=js&"
export * from "./gift-animation.vue?vue&type=script&lang=js&"
import style0 from "./gift-animation.vue?vue&type=style&index=0&id=f2c866f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c866f4",
  null
  
)

export default component.exports